/** @designSystem app-pattern — single-choice option button, moved unchanged from log-ai-usage-dialog.tsx so the AI-tool picker reuses it */
import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";
import { classNames } from "~/utils";

export interface OptionButtonProps {
  id: string;
  label: string;
  selected: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export function OptionButton({ label, selected, onClick, disabled }: OptionButtonProps) {
  const { t } = useLingui();
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      aria-label={t(msg`Select ${label}`)}
      className={classNames(
        "w-full h-10 px-2 py-0 rounded-lg border transition-all duration-200",
        "text-sm font-normal leading-5 whitespace-nowrap focus:outline-hidden focus:ring-1 focus:ring-primary",
        selected
          ? "border border-primary bg-background text-foreground"
          : "border border-required bg-background text-foreground hover:border-muted-foreground",
      )}
    >
      {label}
    </button>
  );
}
